<script setup>
import ContactForm from "./ContactForm.vue";

const { user, tagEvent, displayAlert } = defineProps({
	user: Object,
	tagEvent: Function,
	displayAlert: Function,
});
</script>

<template>
<div>
	<h1>Contact Us</h1>
	<ContactForm
		:user="user"
		:tagEvent="tagEvent"
		:displayAlert="displayAlert"
	/>

	<p>We try to respond promptly to all inquiries and issues.</p>
	<p>Please read our policy on unsolicited ideas (below) before you send us your feedback.</p>

	<details class="accordion">
		<summary><h3 style="padding-right:16px;">Unsolicited Idea <span style="display:inline-block;">Submission Policy</span></h3></summary>
		<p>Brown Juice Co and its employees and contractors do not accept, review or consider any unsolicited ideas, works, materials, proposals, suggestions, artwork, content or the like, including for advertising campaigns, promotions, products, services, technologies, product enhancements, processes, marketing strategies, product names, content or creative materials (all of the foregoing &#8220;submissions&#8221;). Please do not send or provide any submissions in any form to Brown Juice Co or any of its employees or contractors.</p>

		<p>The purpose of this policy is to avoid potential misunderstandings or disputes when Brown Juice Co&#8217;s products, services, technologies, advertising, promotions, marketing strategies or content might seem similar to submissions provided to Brown Juice Co. If, despite our request that you not send us your submissions, you still submit them, then regardless of what your correspondence says, the following terms will apply to your submissions.</p>

		<h3>Terms of Idea Submission</h3>
		<p>You agree that: (1) your submissions and their contents along with related intellectual property rights will automatically become the property of Brown Juice Co, without any compensation to you; (2) Brown Juice Co may use or redistribute the submissions and their contents for any purpose and in any way on an unrestricted basis; (3) there is no obligation for Brown Juice Co to review the submissions; and (4) there is no obligation to keep any submissions confidential.</p>

		<h3>Product Feedback</h3>
		<p>Brown Juice Co does, however, welcome your feedback regarding many areas of Brown Juice Co&#8217;s existing business. If you want to send us feedback, we request that you use the form located at <a href="https://brownjuice.co/contact" target="_blank">brownjuice.co/contact</a>.</p>

		<h3>Feedback and Information</h3>
		<p>Any feedback you provide at this site will be deemed to be non-confidential and not proprietary. Brown Juice Co will be free to use and redistribute such information on an unrestricted basis, without any compensation to you.</p>
	</details>
</div>
</template>
